export const coursesCategoryFilter = () => {

    let page = 1;
    let hasMore = true;
    let loading = false;
    let currentTerm = 'all';
    const container = document.querySelector('.courses-js');

    if (!container) return;

    // ======================
    // LOAD MORE
    // ======================
    const loadMore = async () => {
        if (!hasMore || loading || currentTerm !== 'all') return;

        loading = true;
        page++;

        const res = await fetch(
            `/wp-json/courses/v1/filter?term_id=${currentTerm}&page=${page}&per_page=12`,
            {
                credentials: 'same-origin',
                headers:{
                    'X-WP-Nonce': localizedScript.wp_rest_filter_nonce
                }
            }
        );

        if (!res.ok) {
            loading = false;
            return;
        }

        const data = await res.json();

        hasMore = data.has_more;

        container.insertAdjacentHTML('beforeend', data.html);

        observeLast();

        loading = false;
    };

    // ======================
    // OBSERVER
    // ======================
    const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            loadMore();
        }
    });

    const observeLast = () => {
        const items = container.querySelectorAll('.course-card');
        const last = items[items.length - 1];

        if (last) {
            observer.disconnect();
            observer.observe(last);
        }
    };

    // ======================
    // TAB CLICK
    // ======================
    document.addEventListener('click', async e => {

        const tab = e.target.closest('.course-tab-js');
        if (!tab) return;

        document
            .querySelectorAll('.course-tab-js')
            .forEach(el => el.classList.remove('active'));

        tab.classList.add('active');

        // RESET USER FILTER TABS
        document
            .querySelectorAll('.user-courses-filter-item')
            .forEach(el => el.classList.remove('active'));

        const termId = tab.dataset.id || 'all';

        currentTerm = termId;
        page = 1;
        hasMore = true;

        if (termId !== 'all') {
            hasMore = false; // turn off infinite scroll
        }

        container.classList.add('loading');

        const res = await fetch(
            `/wp-json/courses/v1/filter?term_id=${termId}&per_page=12`,
            {
                credentials: 'same-origin',
                headers:{
                    'X-WP-Nonce': localizedScript.wp_rest_filter_nonce
                }
            }
        );

        const data = await res.json();

        container.innerHTML = data.html;

        container.classList.remove('loading');

        observeLast(); // only for all tab
    });

    // ======================
    // USER COURSES TAB CLICK
    // ======================
    document.addEventListener('click', async e => {

        const tab = e.target.closest('.user-courses-filter-item');
        if (!tab) return;

        document
            .querySelectorAll('.user-courses-filter-item')
            .forEach(el => el.classList.remove('active'));

        tab.classList.add('active');


        // RESET CATEGORY TABS
        document
            .querySelectorAll('.course-tab-js')
            .forEach(el => el.classList.remove('active'));
        currentTerm = 'all';
        const userFilter = tab.dataset.filter || 'all';

        page = 1;
        hasMore = userFilter === 'all';

        container.classList.add('loading');

        const res = await fetch(
            `/wp-json/courses/v1/filter?term_id=${currentTerm}&user_filter=${userFilter}&per_page=12`,
            {
                credentials: 'same-origin',
                headers: {
                    'X-WP-Nonce': localizedScript.wp_rest_filter_nonce
                }
            }
        );

        const data = await res.json();
        if(data.html){
            container.innerHTML = data.html;
        }else{
            container.innerHTML = '<div class=""></div><div class="py-10 text-center">' +
                '<h3 class="text-[24px] p-8">' +
                'We looked everywhere — <br> nothing matched your filters.<br> Try tweaking them a bit.' +
                '</h3></div><div class=""></div>';
        }


        container.classList.remove('loading');

        observeLast();
    });

    // ======================
    // INIT
    // ======================
    observeLast();
};